// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"f16f218a","223":"dedadd9f","453":"5e353627","545":"c244e47c","803":"03d8d116"}[chunkId] + ".chunk.js";
};